function createSessionElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createSessionItem(session, currentSession, { getAvatarClass, getAvatarLetter }) {
  const archived = String(session.status || '').toUpperCase() === 'ARCHIVED';
  const item = createSessionElement('li', `aichat-session-item${currentSession && session.id === currentSession.id ? ' active' : ''}${archived ? ' aichat-session-item--archived' : ''}`);
  item.dataset.sessionId = session.id ?? '';
  const avatar = createSessionElement('div', `aichat-session-avatar ${getAvatarClass(session.roleCode)}`, getAvatarLetter(session.roleCode, session.title));
  const info = createSessionElement('div', 'aichat-session-info');
  info.append(
    createSessionElement('div', 'aichat-session-title', session.title || '新会话'),
    createSessionElement('div', 'aichat-session-meta', `${session.model || ''} · ${session.messageCount || 0} 条`),
  );
  item.append(avatar, info);
  if (archived) {
    item.append(createSessionElement('span', 'aichat-session-archived-tag', '已归档'));
  } else {
    const archive = createSessionElement('button', 'aichat-archive-btn', '×');
    archive.type = 'button';
    archive.dataset.archiveId = session.id ?? '';
    archive.title = '归档';
    item.append(archive);
  }
  return item;
}

export function renderSessionList(root, { sessions = [], currentSession = null, status = 'ACTIVE', keyword = '', getRoleName, getAvatarClass, getAvatarLetter } = {}) {
  if (!root) return;
  if (!sessions.length) {
    const message = keyword ? `未找到与“${keyword}”匹配的会话` : (status === 'ARCHIVED' ? '暂无已归档会话' : '暂无会话，选择角色即可开始');
    root.replaceChildren(createSessionElement('li', 'aichat-session-state', message));
    return;
  }
  const groups = new Map();
  sessions.forEach((session) => {
    const code = session.roleCode || 'unknown';
    groups.set(code, [...(groups.get(code) || []), session]);
  });
  const nodes = [];
  groups.forEach((groupedSessions, roleCode) => {
    const label = createSessionElement('li', 'aichat-session-group-label');
    label.append(createSessionElement('span', '', getRoleName(roleCode) || '通用助手'), createSessionElement('i', '', String(groupedSessions.length)));
    nodes.push(label, ...groupedSessions.map((session) => createSessionItem(session, currentSession, { getAvatarClass, getAvatarLetter })));
  });
  root.replaceChildren(...nodes);
}

export function renderSessionListLoading(root) {
  if (!root) return;
  const item = createSessionElement('li', 'aichat-session-list-skeleton');
  item.setAttribute('aria-label', '会话列表加载中');
  item.append(document.createElement('span'), document.createElement('span'), document.createElement('span'));
  root.replaceChildren(item);
}

export function renderSessionListError(root) {
  if (!root) return;
  const item = createSessionElement('li', 'aichat-session-state aichat-session-list-error');
  const retry = createSessionElement('button', '', '点击重试');
  retry.type = 'button';
  retry.dataset.action = 'retry-load-sessions';
  item.append(createSessionElement('div', '', '会话列表加载失败'), retry);
  root.replaceChildren(item);
}
